var map = {
	"./call.svg": 530,
	"./github.svg": 541,
	"./handshake.svg": 542,
	"./logo-basic.svg": 543,
	"./logo-clipped.svg": 498,
	"./logo.svg": 544,
	"./play.svg": 545,
	"./podium.svg": 546,
	"./schedule.svg": 547,
	"./sponsors/apress.svg": 548,
	"./sponsors/aranja.svg": 549,
	"./sponsors/archilogic.svg": 550,
	"./sponsors/flipkart.svg": 551,
	"./sponsors/gitlab.svg": 552,
	"./sponsors/icelandair.svg": 553,
	"./sponsors/kosmos-og-kaos.svg": 554,
	"./sponsors/mozilla.svg": 555,
	"./sponsors/origo.svg": 556,
	"./sponsors/twg.svg": 557,
	"./sponsors/wuxi-nextcode.svg": 558,
	"./ticket.svg": 559,
	"./tonkvisl.svg": 560,
	"./twitter.svg": 561
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 540;



//////////////////
// WEBPACK FOOTER
// ../images ../~/svg-inline-loader!^\.\/.*\.svg$
// module id = 540
// module chunks = 0